import './DateTile.scss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import cxHelpers from 'util/className';
import { momentInZone } from 'util/dateTime';

@cxHelpers('DateTile')
export default class DateTile extends PureComponent {
  static propTypes = {
    parsableDate: PropTypes.string.isRequired,
  };

  render() {
    const dateTime = momentInZone(this.props.parsableDate, 'parsable_date');
    const month = dateTime.format('MMM');
    const dayNum = dateTime.format('D');
    const dayName = dateTime.format('ddd');

    return (
      <div className={this.cx()}>
        <div>{month}</div>
        <div className={this.cxEl('date-num')}>{dayNum}</div>
        <div>{dayName}</div>
      </div>
    );
  }
}
